<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Customer Management
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Customer</li>
        <li class="active">Customer List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Customer List</h3>
              <div class="action-button pull-right">  
                <div>
                  <input type="text" placeholder="Type here to search and press 'Enter'" v-reset-input='' v-on:keyup="searchCustomer1" class="form-control mrgn-right-20px searchBox" v-model="searchCustomer"/>
                </div>
                <!-- <input type="button" :disabled="loading" class="btn btn-primary mrgn-right-20px" value="Add Customer" v-on:click="showModal()" /> -->
                <router-link class="btn btn-primary" :to="`Customer-addOrUpdate`">Add Customer</router-link>
              </div>
            </div>
              <!-- /.box-header -->
            <div class="loader" v-if="actionInProgress">
              <img src="/static/assets/loader/nivi-loader.svg" />
            </div>
            <div class="box-body">
              <table class="table table-striped table-apps">
                <thead>
                  <!-- <th>Id</th> -->
                  <th>Customer Name <i class="fa fa-arrow-up" @click="sortCustomer('data.name','asc')"></i><i class="fa fa-arrow-down" @click="sortCustomer('data.name','desc')"></i></th>
                  <th align='center'>Country</th>
                  <th>Contract</th>  
                  <th>Created On</th>
                  <th>Edit</th>
                  <th>Status</th>
                </thead>
                <tbody>
                  <tr v-if="customerData.length === 0 && !loading"><td colspan="7" align="center">No Result found.</td></tr>
                  <tr v-show="customerData.length" v-for="(keyword, index) in customerData" :key="index">
                    <td>{{keyword.name}}</td>
                    <td>{{keyword.country_name}}</td>
                    <td>{{customerContractList.find(item => item.value === keyword.contract_status).name}}</td>                
                    <td>
                      <span v-if="keyword.createdAt">{{formatDate(keyword.createdAt, 'd/M/Y hh:ss')}}</span>
                      <span v-if="!keyword.createdAt">--</span>
                    </td>
                    <td>
                      <router-link :to="`Customer-addOrUpdate?customerId=${keyword.id}`"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                    </td>
                    <td>
                        <span v-if="!keyword.is_deleted" class="badge badge-pill btn-success"  v-on:click="showDeleteConfirmationPopup(keyword, index)">Active</span>
                        <span v-if="keyword.is_deleted" class="badge badge-pill btn-danger"  v-on:click="showDeleteConfirmationPopup(keyword, index)">Inactive</span>
                    </td>             
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    
      <deleteConfirmationModal
        v-if="isDeleteConfirmationVisible"        
        @close="closeConfirmationModal" 
        @deleteCustomer="deleteCustomer"
        @deactiveCustomer="deactiveCustomer"
        @activeCustomer="activeCustomer"
        :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
        :confirmationMessage="confirmationMessage" 
        :actionToBePerformed="actionToBePerformed"
        />
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import _ from 'lodash'
import Paginate from 'vuejs-paginate'
import { customerContracts } from '../../../config/constants'
import api from '../../../utils/api'
import deleteConfirmationModal from './../popup/deleteConfirmation'
import { formatDate, getSelectorValue } from '../../../utils/utilities'

export default {
  name: 'KeywordDashboard',
  components: {
    'deleteConfirmationModal': deleteConfirmationModal,
    'paginate': Paginate
  },
  async mounted () {
    await this.getAllCustomer()
    this.loading = false
  },
  data () {
    return {
      formatDate: formatDate,
      customerSearchResult: [],
      customerContractList: customerContracts,
      keywordObj: {},
      searchCustomer: '',
      loading: false,
      actionInProgress: false,
      isModalVisible: false,
      isDeleteConfirmationVisible: false,
      validationErrors: [],
      customerData: [],
      clonedcustomerData: [],
      actionToBePerformed: 'Add Customer',
      confirmationMessage: 'Are you sure you want to delete this customer?',
      rowIndexToBeUpdated: 0
    }
  },
  methods: {
    /**
     * @function closeConfirmationModal
     * @description Function to close delete confirmation popup
     */
    closeConfirmationModal () {
      this.isDeleteConfirmationVisible = false
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    /**
     * @function closeModal
     * @description Function to close modal and reset all the variables
     */
    showDeleteConfirmationPopup (customerData, index) {
      if (customerData.is_deleted) {
        this.actionToBePerformed = 'Activate Customer'
        this.confirmationMessage = 'Are you sure you want to Activate this Customer?'
      } else {
        this.actionToBePerformed = 'Deactivate Customer'
        this.confirmationMessage = 'Are you sure you want to Deactivate this Customer?'
      }
      this.isDeleteConfirmationVisible = true
      this.rowIndexToBeUpdated = index
    },
    /**
     * @function closeModal
     * @description Function to close modal and reset all the variables
     */
    searchCustomer1 (event) {
      console.log(event)
      console.log(this.searchCustomer)
      // let executesearchCustomer = false
      if (this.searchCustomer !== '' && this.searchCustomer !== undefined) {
        if (event.key === 'Enter') {
          // executesearchCustomer = true
          this.getAllCustomer()
        }
      }
    },
    onResetsearchCustomer () {
      this.getAllCustomer()
    },
    /**
     * @function getDataFromGoogleSheet
     * @description Get Keywords from Google sheet
     */
    async getAllCustomer () {
      this.loading = true
      let selector = {}
      selector.isdeleted = false
      if (this.searchCustomer !== '' && this.searchCustomer !== undefined) {
        selector.keyword = { $regex: this.searchCustomer, $options: 'i' }
      }
      let queryParams = {
        selector: getSelectorValue(selector),
        searchText: (this.searchCustomer || '').replace(/'/g, "''"),
        sort: {
          createdAt: -1
        }
      }
      // this.config['stages'] = this.stages
      // api.buildRequest('getAllCustomer', 'POST', {sheetReference: 'keyword', workSheetIndex: 1})
      return new Promise(resolve => {
        api.buildRequest('getCustomerList', 'POST', queryParams)
            .then(response => {
              this.loading = false
              if (response.status === 200) {
                if (response.data.payload.customer.length > 0) {
                  this.customerData = response.data.payload.customer
                  this.clonedcustomerData = this.customerData
                } else {
                  this.customerData = []
                  this.clonedcustomerData = this.customerData
                  if (this.searchCustomer === '') {
                    // this.getKeywordsFromGoogleSheet()
                  }
                }
              } else {
                console.log('something went wrong')
              }
              resolve(true)
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
      })
    },
    closeModal () {
      console.log('inside closeModal function')
      this.rowIndexToBeUpdated = 0
      this.isModalVisible = false
      this.isDeleteConfirmationVisible = false
      this.validationErrors = []
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    deleteCustomer () {
      this.loading = true
      console.log('deleteCustomer')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRowData = this.customerData[this.rowIndexToBeUpdated]
      this.customerData.splice(this.rowIndexToBeUpdated, 1)
      console.log('spliced customerData')
      console.log(this.customerData)
      const params = deletedRowData
      var self = this
      api.buildRequest('deleteCustomer', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            self.closeModal()
            if (response.status === 200) {
              self.isDeleteConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Customer deleted successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isDeleteConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    deactiveCustomer () {
      this.loading = true
      console.log('deactiveCustomer')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRowData = this.customerData[this.rowIndexToBeUpdated]
      deletedRowData.is_deleted = true
      // this.customerData.splice(this.rowIndexToBeUpdated, 1)
      // console.log('spliced customerData')
      console.log(this.customerData)
      const params = deletedRowData
      var self = this
      api.buildRequest('deactivatedCustomer', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            self.closeModal()
            if (response.status === 200) {
              self.isDeleteConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Customer deactivated successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isDeleteConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    activeCustomer () {
      this.loading = true
      console.log('activeCustomer')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRowData = this.customerData[this.rowIndexToBeUpdated]
      deletedRowData.is_deleted = false
      // this.customerData.splice(this.rowIndexToBeUpdated, 1)
      // console.log('spliced customerData')
      console.log(this.customerData)
      const params = deletedRowData
      var self = this
      api.buildRequest('activatedCustomer', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            self.closeModal()
            if (response.status === 200) {
              self.isDeleteConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Customer activated successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isDeleteConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    onChangePage (pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems
    },
    sortCustomer (sortKey, order) {
      this.customerData = _.sortBy(this.customerData, [sortKey])
      if (order === 'desc') {
        this.customerData = _.reverse(this.customerData)
      }
      console.log(`sorted keywords=${this.customerData}`)
    }
  },
  watch: {
    searchCustomer: function () {
      console.log('watching searchkeyowrd')
      if (this.searchCustomer === '') {
        this.getAllCustomer()
      }
    }
  },
  computed: {
    filteredList () {
      this.customerSearchResult = this.customerData.filter(keyword => {
        return keyword.id.toLowerCase().includes(this.searchCustomer.toLowerCase()) || keyword.data.name.toLowerCase().includes(this.searchCustomer.toLowerCase())
      })
      return this.customerSearchResult
    }
  }
}
</script>
<style>
.mrgn-right-20px {
  margin-right: 20px;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
</style>


// WEBPACK FOOTER //
// customerList.vue?8caa32a8